import React, { useEffect, useState } from 'react'
import { Drawer, DrawerContent, DrawerSelectEvent } from '@progress/kendo-react-layout'
import { useLocation, useNavigate } from 'react-router-dom';
import { Roles } from '../../utilities/enums/Roles';

interface IStateDrawer {
    expanded: boolean;
    codeMgmtIsEnabled: boolean;
    children: any;
}

function StateDrawer(props: IStateDrawer) {
    // variables used for navigating and getting current location set selected value
    const navigate = useNavigate();
    const location = useLocation();
    // expression matchs /state/dashboard to set the correct selection on the drawer
    var rx = /\/[a-z]+\/[a-z]+/g;
    var base: any = rx.exec(location.pathname);

    const [expanded, setExpanded] = useState<boolean>(props.expanded);
    const [selected, setSelected] = React.useState<string>(base[0]);
    const [items, setItems] = useState<any>([
        { text: "Home", route: "/", icon: "home", hidden: false },
        { text: "Work Queue", route: "/state/work-queue", icon: "k-i-track-changes-accept-all", hidden: false },
        { text: "Filings", route: "/state/filings", icon: "k-i-file-txt", hidden: false },
        { text: "Code Drafting", route: "/state/draft", icon: "k-i-edit-tools", hidden: false },
        { text: "Historical Drafts", route: "/state/historical-drafts", icon: "k-i-clock", hidden: false },
        { text: "Historical Filings", route: "/state/historical-filings", icon: "k-i-clock", hidden: false },
        { text: "Code Mgmt.", route: "/state/code-management", icon: "k-i-document-manager", hidden: false },
        { text: "Chapter History Mgmt.", route: "/state/chapter-history-management", icon: "k-i-document-manager", hidden: false}
    ]);

    useEffect(() => {
        let userRoles = sessionStorage.getItem('roles');
        if (!!userRoles) {
            let parsedUserRoles: any[] = JSON.parse(userRoles);
            if (parsedUserRoles.includes(Roles.SosOffice)) {
                let itemsCopy = [...items];
                itemsCopy[3].hidden = false;
                setItems(itemsCopy);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onSelect = (e: DrawerSelectEvent) => {
        setSelected(location.pathname);
        navigate(e.itemTarget.props.route);
    };

    const getFilteredDrawerItems = (drawerItem: any) => {
        return (props.codeMgmtIsEnabled === false && drawerItem.text === 'Code Management') ? null : drawerItem;
    };

    useEffect(() => {
        setExpanded(props.expanded)
    }, [props.expanded])

    return (
        <>
            <Drawer
                className="drawer"
                expanded={expanded}
                mini={true}
                position="start"
                mode="push"
                items={items
                    .filter(getFilteredDrawerItems)
                    .map((item: any) => ({
                    ...item,
                    selected: item.route === selected,
                }))}
                // style={{ "height": "100%" }}
                onSelect={onSelect}
            >
                <DrawerContent>
                    <div className="drawer-content body">
                        {props.children}
                    </div>
                </DrawerContent>
            </Drawer>
        </>
    )
}

export default StateDrawer